import { useCallback } from 'react';
import NiceModal from '@ebay/nice-modal-react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';
import FileExport from '@gef-ui/material-icons/FileExport';
import MagnifyingGlassPlus from '@gef-ui/material-icons/MagnifyingGlassPlus';
import Print from '@gef-ui/material-icons/Print';

import Subheader from 'components/atoms/GefMui/Subheader';
import ToolbarTemplate from 'components/atoms/GefMui/ToolbarTemplate/ToolbarTemplate';
import { ComponentLoader } from 'components/index';
import MODALS from 'constants/modals';
import fetch from 'features/common/fetch';
import { useRenderSubheaderTitle } from 'features/common/Subheader/hooks';
import { exportPolicies } from 'features/views/policyOverview/actions';
import { noPoliciesLoaded } from 'features/views/policyOverview/selectors';
import { getContextUser } from 'features/views/userContext/selectors';

export const Toolbar = () => {
	const dispatch = useDispatch();
	const isNoPoliciesLoaded = useSelector(noPoliciesLoaded);

	const contextUser = useSelector(getContextUser);
	const subheaderTitle = useRenderSubheaderTitle({
		contextUser,
		pageTitle: getLabelMessage('policyOverview:title'),
	});

	const handleExport = useCallback(() => {
		dispatch(exportPolicies());
	}, [dispatch]);

	const handlePrint = useCallback(() => {
		window.print();
	}, []);

	const handleOpenAdvancedSearchModal = useCallback(() => NiceModal.show(MODALS.policyOverview_advanced_search), []);

	const subheaderToolbar = (
		<Stack
			direction="row"
			spacing={2}
			sx={{
				justifyContent: 'flex-end',
			}}
		>
			<ComponentLoader fetchStorePath={fetch.constants.urls.policyListExport} ignoreErrors>
				<Button
					variant="text"
					size="small"
					startIcon={<FileExport />}
					disabled={isNoPoliciesLoaded}
					onClick={handleExport}
				>
					{getLabelMessage('policyOverview:policyExport')}
				</Button>
			</ComponentLoader>
			<Button
				variant="text"
				size="small"
				disabled={isNoPoliciesLoaded}
				startIcon={<Print />}
				onClick={handlePrint}
			>
				{getLabelMessage('common:print')}
			</Button>
			<Button
				variant="text"
				size="small"
				startIcon={<MagnifyingGlassPlus />}
				onClick={handleOpenAdvancedSearchModal}
			>
				{getLabelMessage('policyOverview:advancedSearch')}
			</Button>
		</Stack>
	);

	return <ToolbarTemplate leftSide={<Subheader title={subheaderTitle} />} rightSide={subheaderToolbar} />;
};

export default Toolbar;
